import React from 'react';
import { ExternalLink } from 'lucide-react';

const ecosystemProducts = [
  { name: 'Blonect', tag: 'SocialFi', href: 'https://wer2ecosystem.com/#blonect' },
  { name: 'We·R2 Pay', tag: 'Payments', href: 'https://wer2ecosystem.com/#pay' },
  { name: 'We·R2 Swap', tag: 'DEX', href: 'https://wer2ecosystem.com/#swap' },
  { name: 'We·R2 Finance', tag: 'CEX', href: 'https://wer2ecosystem.com/#finance' },
  { name: 'Freedom Homes Club', tag: 'RWA', href: 'https://wer2ecosystem.com/#fhc' },
  { name: 'We·R2 Wallet', tag: 'Wallet', href: 'https://wer2ecosystem.com/#wallet' },
];

export const EcosystemBridge = () => {
  return (
    <section className="relative py-14 border-t border-[#1a4138] bg-[#06120e]/40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row gap-8 items-start lg:items-center justify-between mb-8">
          <div className="max-w-xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/15 border border-primary/30 text-primary text-xs font-semibold tracking-wide uppercase mb-3">
              <span className="w-1.5 h-1.5 rounded-full bg-primary" />
              <span>Part of the We·R2 Ecosystem</span>
            </div>
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-2">
              Explora el ecosistema completo
            </h3>
            <p className="text-sm text-slate-400 leading-relaxed">
              Builders Portal es una pieza del ecosistema soberano We·R2. Conoce los productos hermanos que comparten infraestructura, gobernanza BGT y Sovereign Nodes.
            </p>
          </div>

          <a
            href="https://wer2ecosystem.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary text-black font-semibold text-sm hover:bg-primary/90 transition-all glow-primary"
            data-testid="ecosystem-bridge-main"
          >
            <span>wer2ecosystem.com</span>
            <ExternalLink className="w-4 h-4" />
          </a>
        </div>

        {/* Product chips grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3" data-testid="ecosystem-bridge-products">
          {ecosystemProducts.map((p) => (
            <a
              key={p.name}
              href={p.href}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex flex-col gap-1 p-4 rounded-xl bg-black/40 border border-[#1a4138] hover:border-primary/50 hover:bg-[#06120e] transition-all"
              data-testid={`ecosystem-product-${p.name.toLowerCase().replace(/[^a-z0-9]/g, '-')}`}
            >
              <span className="text-[10px] uppercase tracking-wider text-primary/80 font-semibold">{p.tag}</span>
              <div className="flex items-center justify-between">
                <span className="text-white font-medium text-sm">{p.name}</span>
                <ExternalLink className="w-3.5 h-3.5 text-slate-500 group-hover:text-primary transition-colors" />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
